/**
 * @file DeleteItem
 */
'use strict'

/**
 * @classname DeleteItem
 * @classdesc deleteItem
 */
export default class DeleteItem {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('DeleteItem.constructor')
		this._name = $e.attr('data-name')
		$e.on('click', () => this.onClick())
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof DeleteItem
	 * @return {undefined}
	 */
	onClick() {
		console.log('DeleteItem.onClick')
		$('#modal-delete span.name').text(this._name)
	}
}
